import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import useConfigs from "../../hooks/useConfigs";
import useThemes from "../../hooks/useThemes";

const SelectContainer = styled.div`
  width: ${(props) => props.width};
  margin-bottom: 1rem;

  h4 {
    color: ${(props) => props.color};
    font-weight: 700;
    text-transform: uppercase;
  }

  select {
    width: 100%;
    padding: 1rem 2rem;
    border-radius: 2rem;
    border: 1px solid
      ${(props) => (props.error ? "#ff7777" : props.bordercolor)};
    background-color: ${(props) => props.backgroundinput};
    color: ${(props) => props.colorinput};

    &:focus {
      border: 2px solid ${(props) => props.bordercolor};
      outline: none;
    }
  }

  p {
    margin-top: 0.5rem;
    color: #ff7777;
  }

  @media (max-width: 1023px) {
    width: 100%;
  }
`;

const CustomSelect = ({
  label,
  width,
  error,
  value,
  onChange,
  onBlur,
  data,
}) => {
  const { fontSizeMultiplier } = useConfigs();
  const { colorPrincipal, colorCuarto, colorSexto, backgroundDecimo } =
    useThemes();

  return (
    <SelectContainer
      color={colorPrincipal}
      bordercolor={colorSexto}
      backgroundinput={backgroundDecimo}
      colorinput={colorCuarto}
      error={error}
      width={width}
    >
      <h4 style={{ fontSize: 15 * fontSizeMultiplier }}>{label}</h4>

      <select
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        style={{ fontSize: 15 * fontSizeMultiplier }}
      >
        <option value="">Seleccionar</option>
        {data.map((item, index) => (
          <option key={index} value={item.value}>
            {item.name}
          </option>
        ))}
      </select>

      <p style={{ fontSize: 15 * fontSizeMultiplier }}>{error?.message}</p>
    </SelectContainer>
  );
};

export default CustomSelect;

CustomSelect.propTypes = {
  label: PropTypes.string,
  width: PropTypes.string,
  error: PropTypes.object,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  data: PropTypes.array,
};

CustomSelect.defaultProps = {
  width: "100%",
};
